

export const SET_TABLE_CHECK = 'SET_TABLE_CHECK';
export const SET_SITE_CONFIG = 'SET_SITE_CONFIG';



// WEBPACK FOOTER //
// ./src/store/mutation-type.js